import Icon from "./IconBase.js";
const CloseIconWhite = (props) => {
  return (
    <Icon width="20" height="20" viewBox="0 0 22 22" {...props}>
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10.9963 6.99609L7.00293 10.9894"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.9976 10.9916L7.00098 6.99414"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.612 1.29199H5.38783C2.87033 1.29199 1.29199 3.07449 1.29199 5.59699V12.4037C1.29199 14.9262 2.86283 16.7087 5.38783 16.7087H12.6112C15.137 16.7087 16.7087 14.9262 16.7087 12.4037V5.59699C16.7087 3.07449 15.137 1.29199 12.612 1.29199Z"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </Icon>
  );
};
export default CloseIconWhite;
